var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.isEnabled
    ? _c(_setup.CSelect, {
        staticClass: "preview-select",
        attrs: {
          options: _setup.listPreview,
          "model-transform": _setup.valueReducer,
        },
        on: { input: _setup.onPreviewSelected },
        model: {
          value: _setup.selectedPreview,
          callback: function ($$v) {
            _setup.selectedPreview = $$v
          },
          expression: "selectedPreview",
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }